/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".event-location-row[_ngcontent-%COMP%]{display:flex;flex-direction:row;flex-wrap:wrap;width:100%}.event-location-column[_ngcontent-%COMP%]{display:flex;flex-direction:column;flex-basis:100%;flex:1}.event-location-header[_ngcontent-%COMP%]{font-weight:700}.event__content[_ngcontent-%COMP%]{font-size:.789em;color:#626767;line-height:1.36;white-space:pre-wrap}"];
export { styles as styles };
